import { BACKEND_URL } from '@/constants';
import { useEnhancedRouter } from '@/hooks/useEnhancedRouter';
import cn from 'classnames';
import styles from './BannerPreview.module.scss';

type BannerPreviewProps = {
  className?: string;
  image: string;
  imageTablet: string;
  imageMobile: string;
  link: string;
};

export function BannerPreview({
  className,
  image,
  imageTablet,
  imageMobile,
  link,
}: BannerPreviewProps) {
  const desktopClassName = cn(styles.wrapper, styles.desktop, className);
  const tabletClassName = cn(styles.wrapper, styles.tablet, className);
  const mobileClassName = cn(styles.wrapper, styles.mobile, className);
  const { push } = useEnhancedRouter();

  const handleBannerClick = () => {
    if (link && link.includes('http')) {
      window.open(link, '_blank');
    } else {
      push(link);
    }
  };

  return (
    <>
      <img
        src={`${BACKEND_URL}${image}`}
        alt="banner"
        loading="lazy"
        className={desktopClassName}
        onClick={handleBannerClick}
      />
      <img
        src={`${BACKEND_URL}${imageTablet}`}
        alt="banner"
        loading="lazy"
        className={tabletClassName}
        onClick={handleBannerClick}
      />
      <img
        src={`${BACKEND_URL}${imageMobile}`}
        alt="banner"
        loading="lazy"
        className={mobileClassName}
        onClick={handleBannerClick}
      />
    </>
  );
}
